import React, {useState} from 'react'
import { motion } from 'framer-motion'
import { transition1 } from '../transitions';
import WeightOfWaters from '../components/WeightofWaters';
import We from './We';
import MGOP from '../components/MGOP';



const Editions = () => {

  const [activeProject, setActiveProject] = useState("We")

  return (
  <>
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='section overflow-auto h-screen'
    >
     <div className='h2 lg:px-40 pt-20 text-center lg:text-start  lg:pt-24 lg:pb-10'>
        
     </div>

     <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 100, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      className=' lg:flex items-center justify-center flex mt-10 lg:mt-10'
    >
     <div className='flex lg:flex-row flex-col items-center self-center rounded-2xl border-zinc-900 border-2 w-fit justify-center p-3  lg:p-6'>
      <div onClick={() => setActiveProject("We")} className={`h6 mt-1 px-4 lg:px-10 hover:text-black hover:cursor-pointer  ${activeProject === "We" ? 'text-black' : 'text-gray-500'}`}>
      We Collective Art
      </div>
      <div onClick={() => setActiveProject("WeightOfWaters")} className={`h6 mt-1 px-4 lg:px-10 hover:text-black hover:cursor-pointer  ${activeProject === "WeightOfWaters" ? 'text-black' : 'text-gray-500'}`}>
      Weight of Waters 
      </div>
      <div onClick={() => setActiveProject("MGOP")} className={`h6 mt-1 px-4 lg:px-10 hover:text-black hover:cursor-pointer  ${activeProject === "MGOP" ? 'text-black' : 'text-gray-500'}`}>
      Mapping Geographies of Power 
      </div>
     </div>
     </motion.section>
     {activeProject === "We" && (
      <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 100, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}>
      <We/>
     </motion.section>)}

     {activeProject === "WeightOfWaters" && (
      <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 100, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}> 
      <WeightOfWaters/>
      </motion.section>
     )}

     {activeProject === "MGOP" && (
      <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 100, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}> 
      <MGOP/>
      </motion.section>
     )}
     
    </motion.section>
    </>
  )
}

export default Editions